import { TOKEN_KEY } from '@/consts/const';
import type { CreateAuditRequest } from '@/types/auditApiTypes';
import { buildAuditInterceptedRequest } from './serializeAuditRequest';
import { resolveAuditActionGroupType } from './resolveAuditActionGroupType';

const AUDIT_ENDPOINT = '/api/audit';

export async function sendPreRequestAuditIfMatched(url: string, options: RequestInit): Promise<void> {
  const actionGroupType = resolveAuditActionGroupType(url);

  if (!actionGroupType) {
    return;
  }

  const request = await buildAuditInterceptedRequest(url, options);
  const payload: CreateAuditRequest = {
    actionGroupType,
    request,
  };

  const baseUrl = process.env.NEXT_PUBLIC_API_URL ?? '';
  const accessToken = typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;

  try {
    await fetch(`${baseUrl}${AUDIT_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.warn('[audit] Failed to send pre-request audit', error);
  }
}
